var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRwandaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10239_105581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V60H0V0Z",
    fill: "#20603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V45H0V0Z",
    fill: "#FAD201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V30H0V0Z",
    fill: "#00A1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5504 15.6751L66.8503 16.0668L73.217 18.1835L66.6503 16.8251L72.2587 20.5085L66.2587 17.4918L70.7087 22.5168L65.7003 18.0585L68.717 24.0585L65.0253 18.4501L66.3753 25.0085L64.267 18.6501L63.8753 25.3502L63.792 15.5918L73.5504 15.6751Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5504 15.6745L66.8503 15.2828L73.217 13.1661L66.6503 14.5245L72.2587 10.8411L66.2587 13.8578L70.7087 8.83278L65.7003 13.2911L68.717 7.2911L65.0253 12.8995L66.3753 6.3411L64.267 12.6995L63.8753 5.99943L63.792 15.7578L73.5504 15.6745Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2006 15.6751L60.9006 16.0668L54.5339 18.1835L61.1006 16.8251L55.4923 20.5085L61.4923 17.4918L57.0423 22.5168L62.0506 18.0585L59.034 24.0585L62.7256 18.4501L61.3756 25.0085L63.484 18.6501L63.8757 25.3502L63.959 15.5918L54.2006 15.6751Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2006 15.6745L60.9006 15.2828L54.5339 13.1661L61.1006 14.5245L55.4923 10.8411L61.4923 13.8578L57.0423 8.83278L62.0506 13.2911L59.034 7.2911L62.7256 12.8995L61.3756 6.3411L63.484 12.6995L63.8757 5.99943L63.959 15.7578L54.2006 15.6745Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8749 18.5331C65.4536 18.5331 66.7333 17.2534 66.7333 15.6748C66.7333 14.0961 65.4536 12.8164 63.8749 12.8164C62.2963 12.8164 61.0166 14.0961 61.0166 15.6748C61.0166 17.2534 62.2963 18.5331 63.8749 18.5331Z",
    fill: "#E5BE01",
    stroke: "#00A1DE",
    strokeWidth: 0.283335
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10239_105581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwandaIcon);
export default __webpack_public_path__ + "static/media/rwandaIcon.dc7049419ee3bebd55cd3b6bcfcd7001.svg";
export { ForwardRef as ReactComponent };